import { Grid, makeStyles } from '@material-ui/core'
import DazzedHeadingForGrid from 'components/common/text/DazzedHeadingForGrid'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { Bar, BarChart, CartesianGrid, Cell, LabelList, ResponsiveContainer, XAxis, YAxis } from 'recharts'
import ChartLegendIcon from './common/BarGraphWidget/BarGraphWidgetLegendIcon'
import BarGraphWidgetSkeleton from './common/BarGraphWidget/BarGraphWidgetSkeleton'
import BaseWidget from './common/BaseWidget'

const useStyles = makeStyles(theme => ({
  baseWidget: {
    paddingBottom: 0,
    flexGrow: 1,
    display: 'flex'
  },
  root: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
    width: '100%'
  },
  chartContainer: {
    height: '80%',
    width: '90%',
    maxHeight: 300,
    maxWidth: 380
  },
  legend: {
    height: '10%',
    width: '100%',
    maxWidth: 420,
    display: 'flex',
    justifyContent: 'space-around',
    alignItems: 'center',
    padding: '0 10px'
  },
  legendItem: {
    display: 'flex',
    alignItems: 'center',
    marginRight: '10px',
    fontSize: 12
  }
}))

const SCANS_BAR_COLOR = '#8FB4FF'
const NEEDS_ATTENTION_BAR_COLOR = '#3C52EF'

const ScansAttentionRatioGraph = ({ totalScans = 100, totalNeedsAttention = 20, isLoading = false }) => {
  const classes = useStyles()
  const { t } = useTranslation()

  const barsData = [
    {
      name: t('pages.copilotControl.widgets.scansNeedAttentionRatio.legend.taggedScans'),
      value: totalScans,
      legendColor: SCANS_BAR_COLOR
    },
    {
      name: t('pages.copilotControl.widgets.scansNeedAttentionRatio.legend.attentionRequired'),
      value: totalNeedsAttention,
      legendColor: NEEDS_ATTENTION_BAR_COLOR
    }
  ]

  return isLoading ? (
    <BarGraphWidgetSkeleton />
  ) : (
    <BaseWidget className={classes.baseWidget} carousel={false}>
      <div className={classes.root}>
        <Grid container className={classes.legend}>
          {barsData.map((item, index) => (
            <div key={index} className={classes.legendItem}>
              <ChartLegendIcon color={item.legendColor} />
              <DazzedHeadingForGrid regular xs={12} sm={12} md={12} lg={14} xl={14} style={{ marginLeft: 5 }}>
                {item.name}
              </DazzedHeadingForGrid>
            </div>
          ))}
        </Grid>
        <div className={classes.chartContainer}>
          <ResponsiveContainer width="100%" height="100%">
            <BarChart data={barsData} margin={{ top: 20, right: 30, left: 0, bottom: 10 }} barCategoryGap="30%">
              <CartesianGrid vertical={false} strokeOpacity={0.5} />
              <XAxis dataKey="name" style={{ opacity: 0.3 }} tick={false} axisLine={false} />
              <YAxis style={{ opacity: 0.4 }} tickCount={5} />

              <Bar dataKey="value" opacity={0.8} radius={[10, 10, 0, 0]}>
                <Cell key={`scans`} fill={SCANS_BAR_COLOR} />
                <Cell key={`needsAttention`} fill={NEEDS_ATTENTION_BAR_COLOR} />
                <LabelList dataKey="value" position="top" style={{ fill: '#000', fontSize: 12, fontWeight: 'bold' }} />
              </Bar>
            </BarChart>
          </ResponsiveContainer>
        </div>
      </div>
    </BaseWidget>
  )
}

export default ScansAttentionRatioGraph
